import { ListViewMode } from '../../constants/list-view-mode.constant';
import { MatDialogRef } from '@angular/material/dialog';
import { ShipmentFiltersDatepickerRangeOutput, StatisticFilterModel } from '../models/shipment-filters.model';
import { ExportDialogComponent } from '../../../../../ui-kit/export-dialog';
import { ExportType } from '../../../../constants';

export class ShipmentExportToFileStart {
  public static readonly type = '[ShipmentsExportToFile] Start';

  constructor(
    public payload: {
      reportName: string;
      reportType: ExportType;
      searchRequestView: {
        filter: Partial<ShipmentFiltersDatepickerRangeOutput>;
        statisticFilter: StatisticFilterModel;
        viewMode: ListViewMode;
      };
      dialogRef: MatDialogRef<ExportDialogComponent>;
      navigationNeeded: boolean;
    },
  ) {}
}
